import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { API_ADVERT_REVIEW_CHECK_NAME, REVIEW_CHECK_INIT_URL, REVIEW_CHECK_SEARCH_URL } from '#reviewCheck/constants';
import { LoadMorePayloadType, ReviewCheckInitResponseType, SearchResponseType } from '#reviewCheck/api';

const getApiAdvertReviewCheck = (diContainer: Container) => {
  const apiAdvertReviewCheck = createApi({
    reducerPath: API_ADVERT_REVIEW_CHECK_NAME,
    baseQuery: getBaseQuery(diContainer),
    tagTypes: ['init'],
    endpoints: (builder) => ({
      init: builder.query<ReviewCheckInitResponseType, void>({
        query: () => ({
          url: REVIEW_CHECK_INIT_URL,
        }),
        providesTags: ['init'],
      }),
      search: builder.query<SearchResponseType, string>({
        query: (search) => ({
          url: REVIEW_CHECK_SEARCH_URL,
          params: {
            search,
          },
        }),
      }),
      loadMore: builder.query<SearchResponseType, LoadMorePayloadType>({
        query: ({ search, page }) => ({
          url: REVIEW_CHECK_SEARCH_URL,
          params: {
            search,
            page,
          },
        }),
        async onQueryStarted({ search }, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          dispatch(
            apiAdvertReviewCheck.util.updateQueryData('search', search, (draft) => {
              draft.reviews.pagination = data.reviews.pagination;
              draft.reviews.items.push(...data.reviews.items);
            }),
          );
        },
      }),
    }),
  });

  return apiAdvertReviewCheck;
};

export { getApiAdvertReviewCheck };
